import { CSSProperties } from 'react';

import { bodyWidth } from 'constants/values';

export const container: CSSProperties = {
  backgroundColor: '#D5D5D5',
  width: '100%',
};

export const body: CSSProperties = {
  backgroundColor: '#D5D5D5',
  height: 582,
  margin: 'auto',
  position: 'relative',
  width: bodyWidth,
};

export const image1: CSSProperties = {
  height: 324,
  left: 344,
  position: 'absolute',
  top: 108,
  width: 420,
};

export const image2: CSSProperties = {
  height: 475,
  left: 852,
  position: 'absolute',
  top: 68,
  width: 374,
};

export const image3: CSSProperties = {
  height: 84,
  left: 688,
  position: 'absolute',
  top: 450,
  width: 100,
};
